"use client";

import { TRANSLATION_OPTIONS } from "@/components/screen/get-quote/components/Checkout/constants";
import { useSearchParams } from "next/navigation";

export const useStartOrderConfirmedQueryData = () => {
  const searchParams = useSearchParams();

  const get = (key: string) => searchParams.get(key);
  const getAll = (key: string) => searchParams.getAll(key);

  return {
    pageCount: Number(get("pageCount") ?? 0),
    wordCount: Number(get("wordCount") ?? 0),
    documents: Number(get("documents") ?? 0),

    firstName: get("firstName") ?? "",
    lastName: get("lastName") ?? "",
    email: get("email") ?? "",

    translationType: get("translationType") ?? "",
    fromLanguage: get("fromLanguage") ?? "",
    toLanguage: get("toLanguage") ?? "",

    delivery: getAll("delivery"),

    isCertified: get("translationType") === TRANSLATION_OPTIONS.certified,
  };
};
